
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import ProductFieldsSection from "./ProductFieldsSection";
import { NotificationProductData } from "@/types/notifications";

interface InternalRecipientsGroupProps {
  internalRecipients: {
    group1: boolean;
    group2: boolean;
  };
  products: NotificationProductData[];
  onInternalCheckboxChange: (group: 'group1' | 'group2') => void;
  onProductsChange: (products: NotificationProductData[]) => void;
}

const InternalRecipientsGroup = ({
  internalRecipients,
  products,
  onInternalCheckboxChange,
  onProductsChange
}: InternalRecipientsGroupProps) => {
  return (
    <div className="space-y-2">
      <Label>Goes</Label>
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="internal-group1"
            checked={internalRecipients.group1}
            onCheckedChange={() => onInternalCheckboxChange('group1')}
          />
          <Label 
            htmlFor="internal-group1" 
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Inkoop Goes
          </Label>
        </div>
        
        {/* Product Fields Section - shows only when Inkoop Goes is checked */}
        <ProductFieldsSection 
          showProductFields={internalRecipients.group1}
          products={products}
          onProductsChange={onProductsChange}
        />
      </div>
    </div>
  );
};

export default InternalRecipientsGroup;
